// extracted by mini-css-extract-plugin
module.exports = {"button":"share-cover-button_button__2j6Yz"};